'use client';
import { usePathname } from 'next/navigation';

import ErrorPage404 from '@components/views/error/ErrorPage404';

export default function NotFound() {
  const path = usePathname();
  return (
    <>
      <head>
        <title>404 Sayfa Bulunamadı! | Setur</title>
        <meta
          name='description'
          content='Bu sayfa kaldırılmış veya değiştirilmiş olabilir. Tatil fırsatlarını kaçırmamak için otel, tur ve gemi ürünlerimizi hemen inceleyin!'
        />
        <link rel='canonical' href={`${process.env.NEXT_PUBLIC_HOST}${path}`} />
      </head>
      <ErrorPage404 />
    </>
  );
}
